import { api } from '@/api/http'

export interface PartItem {
  id: number
  userId: number
  title: string
  slug: string
  partNumber: string
  category: string
  subCategory?: string
  brand: string
  vehicleBrand?: string
  vehicleModel?: string
  vehicleYear?: number | string
  engineVariant?: string
  vehicleType?: string
  availability?: string
  isFeatured?: boolean
  price: number | string
  stockCount: number
  inStock: boolean
  isOEM: boolean
  condition: string
  compatibility: string[]
  warranty?: string | null
  shippingInfo?: string | null
  returnPolicy?: string | null
  description?: string | null
  specifications?: Record<string, any> | null
  images: string[] | { url?: string }[]
  status: string
  createdAt: string
  user?: {
    id: number
    firstName: string
    lastName: string
    role: string
  }
}

export interface PartsResponse {
  items: PartItem[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export const partsService = {
  getParts: (params: Record<string, any> = {}) =>
    api.get<PartsResponse>('/parts', { params }),

  getCategories: () =>
    api.get<string[]>('/parts/categories'),

  getPartBySlug: (slug: string) =>
    api.get<PartItem>(`/parts/${slug}`),

  createPart: (data: any) =>
    api.post<PartItem>('/parts', data),

  updatePart: (id: number, data: any) =>
    api.put<PartItem>(`/parts/${id}`, data),

  toggleFeatured: (id: number) =>
    api.patch<PartItem>(`/parts/${id}/featured`),

  deletePart: (id: number) =>
    api.delete<{ success: boolean }>(`/parts/${id}`),
}
